<script setup>
import Dialog from "primevue/dialog";
import ReservationDetail from "./ReservationDetail.vue";
import Button from "primevue/button";

const visible = defineModel('visible');

const props = defineProps({
    reservation: Object
})
</script>

<template>
    <Dialog v-model:visible="visible" closable modal class="overflow-hidden" :style="(reservation?.form_data && !Array.isArray(JSON.parse(reservation?.form_data))) || reservation?.id_services ? 'width: 600px' : 'width: 400px'">
        <template #container>
           <div class="relative">
               <div class="fixed top-2 right-2">
                   <Button icon="pi pi-times" rounded severity="secondary" @click="visible = false"></Button>
               </div>
               <ReservationDetail :reservation="reservation" :changeable="false" />
           </div>
        </template>
    </Dialog>
</template>

<style scoped lang="scss">

</style>
